import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Star",
  "use": "Star-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol viewBox=\"0 0 21 20\" id=\"Star\">\n  <path fill=\"currentColor\" d=\"M15.735 12.67l1.49 7.33-6.583-3.685L4.058 20l1.49-7.33L0 7.62l7.495-.87L10.642 0l3.147 6.79 7.495.87z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol